import React from 'react';
import { Link } from 'react-router-dom';
import { Project } from '../../data/projects';
import { TermsContent } from '../../data/projectContent';
import { projectNavigation, type ProjectNavigation } from './projectNavigation';
import './ProjectTemplates.css';

interface Props {
  project: Pick<Project, 'name' | 'slug'>;
  content: TermsContent;
  navigation?: ProjectNavigation;
}

const ProjectTermsTemplate: React.FC<Props> = ({ project, content, navigation }) => {
  const { home, basePath } = projectNavigation(project, navigation);
  return (
    <div className="project-page project-terms-page">
      <div className="project-page-container">
        <div className="project-page-header">
          <Link to={home.path} className="project-back-link">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6" />
            </svg>
            Back to {home.label}
          </Link>
          <h1>{content.title ?? 'Terms of Service'}</h1>
          <p className="project-page-subtitle">Effective: {content.effectiveDate}</p>
        </div>

        <div className="project-page-content">
          <p className="project-page-intro">{content.intro}</p>

          {content.sections.map((section, index) => (
            <section key={index} className="project-content-section">
              <h2>{section.title}</h2>
              {Array.isArray(section.content) ? (
                <ul>
                  {section.content.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p>{section.content}</p>
              )}
            </section>
          ))}

          <div className="project-page-footer">
            <p>&copy; {new Date().getFullYear()} {project.name} by Apres AI LLC. All rights reserved.</p>
            <p className="project-footer-links">
              <Link to={home.path}>{home.label} Home</Link>
              {' · '}
              <Link to={`${basePath}/privacy`}>Privacy Policy</Link>
              {' · '}
              <Link to={`${basePath}/support`}>Support</Link>
              {' · '}
              <Link to="/">Apres AI</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectTermsTemplate;
